import { ErrorCatcher } from '../../tools/error-catcher';
import { ImageWordpress } from '../../types/shared';
import { getImageObject, getPublisherObject } from './schema';
import dayjs from 'dayjs';


type CategoryType = {
    name: string;
};

type SinglePostProps = {
    content: {
        postTitle: string;
        preamble: string;
        strippedContent: string;
        featuredImage: ImageWordpress;
        date: string;
        categories: Array<CategoryType>;
        author: {
            visibleName: string;
            profilePicture: ImageWordpress;
        };
    };
    postType: string;
    hasAuthor: boolean;

};

const postSchemaContent = (props: SinglePostProps) => {
    const { content, postType, hasAuthor } = props;

    const schema = JSON.stringify({
        '@context': 'https://schema.org/',
        '@type': postType,
        'headline': content?.postTitle,
        'description': content?.preamble,
        'keywords': content?.categories?.map((category: CategoryType) => category?.name),
        'articleBody': content?.strippedContent,
        'author': hasAuthor ? {
            '@type': 'Person',
            'name': content?.author?.visibleName,
            'image': content?.author?.profilePicture ? getImageObject(content?.author?.profilePicture) : null,
        } : undefined,
        'image': getImageObject(content?.featuredImage),
        'datePublished': content?.date ? dayjs(new Date(content?.date)).format('YYYY-MM-DD') : undefined,
        'publisher': getPublisherObject(),
    });

    return schema;
};

export const SinglePostSchema = (props: SinglePostProps) => {
    return (
        <ErrorCatcher componentName="Post listing Schema">
            <script type="application/ld+json">{postSchemaContent(props)}</script>
        </ErrorCatcher>
    );
};